import React from "react";
import { Alert, Button, Spinner } from "reactstrap";
import { useStripeConnect } from "./StripeConnectContext";

/**
 * Porcher-styled status banner driven entirely by Stripe's own account
 * status (never invented from Firebase). This is the only place on the
 * Payments page that summarizes status in plain language — the embedded
 * Stripe components below it show the authoritative details.
 */
const StripeStatusBanner = () => {
  const { status, statusLoading, error, start, started, publishableKeyMissing } = useStripeConnect();

  if (statusLoading) {
    return (
      <div className="text-center py-3">
        <Spinner color="primary" size="sm" />
      </div>
    );
  }

  if (error) {
    return <Alert color="danger" className="py-2 small mb-4">{error}</Alert>;
  }

  if (publishableKeyMissing) {
    return (
      <Alert color="danger" className="mb-4">
        Payouts aren&apos;t configured yet — missing Stripe publishable key.
      </Alert>
    );
  }

  if (!status?.connected) {
    return (
      <Alert color="warning" className="mb-4 d-flex align-items-center justify-content-between flex-wrap gap-2">
        <div>
          <i className="bx bx-info-circle me-2" />
          <strong>Setup incomplete.</strong> Connect a payout account so Porcher can deposit
          collected rent directly to you.
        </div>
        {!started && (
          <Button color="primary" size="sm" onClick={start}>
            Set up rent payouts
          </Button>
        )}
      </Alert>
    );
  }

  if (!status.onboardingComplete) {
    return (
      <Alert color="warning" className="mb-4">
        <i className="bx bx-error me-2" />
        <strong>Verification required.</strong> Stripe needs a bit more information before
        payouts can start.
      </Alert>
    );
  }

  return (
    <Alert color="success" className="mb-4">
      <i className="bx bxs-check-circle me-2" />
      <strong>Rent payouts are set up.</strong> Stripe securely manages your payout account.
    </Alert>
  );
};

export default StripeStatusBanner;
